//Categories
var allCategories = ["Senate", "House of Representatives"];

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/womenData.csv")
  .await(ready);

function ready(error, us, data) {
  
  if (error) throw error; 

  // Map the categories to the data
  allCategories = d3.set(data.map(function(d) { return d.category; })).values();


  // Make a map for each category
  var charts = allCategories.map(makeChart);

  d3.select(window).on("resize", function() {
    charts.forEach(function(chart) {
      chart.resize();
    })
  });


  function makeChart(category, chartIndex) {

    var chartData = data.filter( function (d) {
      return d.category === category;
    });

    //Pair data with state id
    var dataStatus = {};
    chartData.forEach(function(d) { dataStatus[d.FIPS] = d.status; });
    
    //Append individual chart div 
    var chartContainer = d3.select(".gia-chart").append("div")
      .attr("class", "g-chart-container");

    //Sets dimensions
    var margin = {top: 0, left: 5, bottom: 5, right: 5},
      width = d3.select(".g-chart-container").node().clientWidth,
      width = width - margin.left - margin.right,
      mapRatio = .65,
      height = width * mapRatio;

    //Tells the map what projection to use
    var projection = d3.geo.albersUsa()
      .scale(width *1.25)
      .translate([width / 2, height / 2]);

    //Tells the map how to draw the paths from the projection
    var path = d3.geo.path()
      .projection(projection);


    //Appends the property name to the individual chart container
    var chartCategory = chartContainer.append("h5")
      .attr("class", "g-category");   

    chartCategory.text( category );  

    //Appends the property chart to the individual chart container
    var chart = chartContainer.append("div")
      .attr("class", "g-chart"); 

    //Appened svg to page
      var map = chart.append("svg")
        .style('height', height + 'px')
        .style('width', width + 'px');    

    //Append states
    map.append("g")
      .attr("class", "states")
      .selectAll("path")
      .data(topojson.feature(us, us.objects.states).features)
      .enter().append("path")
      .attr("d", path)
      .style("fill", function(d) {
        if(dataStatus[d.id] === "N") {
          return "#4bc6df";
        }
        if(dataStatus[d.id] === "X") {
          return "#ffbb00";
        }
        else {
          return "#dcdcdc";
        }
      });

    /*WINNING CODE  
    //Senate 
    if(chartIndex === 0) {
      
      //Select AZ
      map.append("path")
        .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "4" || b.id == "4"; }))
        .attr("d", path)
        .attr("class", "outline");
      }  
      //Select NV  
      map.append("path")
        .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "32" || b.id == "32"; }))
        .attr("d", path)
        .attr("class", "outline");  

      //Select PA  
      map.append("path")
        .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "42" || b.id == "42"; }))
        .attr("d", path)
        .attr("class", "outline");   

      //Select UT  
      map.append("path")
        .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "49" || b.id == "49"; }))
        .attr("d", path)
        .attr("class", "outline");     
    }

    //House  
    if(chartIndex === 1) {
      
      //Select DE  
      map.append("path")
        .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "10" || b.id == "10"; }))
        .attr("d", path)
        .attr("class", "outline"); 

      //Select IA  
      map.append("path")
        .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "19" || b.id == "19"; }))
        .attr("d", path)
        .attr("class", "outline");   
    }   
    */   

    return {
      resize: function () {

        var w = d3.select(".g-chart-container").node().clientWidth;

        //Adjust things when the window size changes
        width = w - margin.left - margin.right;
        height = width * mapRatio;
    
        //Update projection
        var newProjection = d3.geo.albersUsa()
          .scale(width*1.25)
          .translate([width / 2, height / 2]);

        //Update path
        path = d3.geo.path()
          .projection(newProjection);    

        //Resize the map container
        map
          .style('width', width + 'px')
          .style('height', height + 'px');

        //Resize the map
        map.selectAll("path").attr('d', path);
      }
    }

  }
}  
